import { render, staticRenderFns } from "./SkupDodatniSadrzajBase.vue?vue&type=template&id=f6812c58&scoped=true&"
import script from "./SkupDodatniSadrzajBase.vue?vue&type=script&lang=js&"
export * from "./SkupDodatniSadrzajBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6812c58",
  null
  
)

export default component.exports